import * as types from '../mutation-types'
import { API } from '../../api'
import { RECORD_DATA_MANAGER, GROUP_DATA_MANAGER } from '../../data'
import { UTILS } from '../../utils';

export default {
    namespaced: true,
    state: {
        gotRecordData: false,
        gotRecordRecentlyData: false,
        recordFtime: 0,
        recordOriginalData: {},
        recordTotalData: [],
        largestGlanceTime: 0,
        recordListData: [],
        recordCurOrderIndex: 3,
        noRecordData: false,
        showSamePop: false,
        recordSameEightWordList: [],
    },
    getters: {},
    mutations: {
        [types.RECORD_INIT_LIST](state) {
            var tempArr = [];
            // 轮询机制：遍历数据取到最大f_time值再次请求，直到获取到的list为空
            function getData() {
                return new Promise((resolve, reject) => {
                    API.getAllList({
                        "f_time": state.recordFtime
                    }, function (data) {
                        // 没有分组数据先处理分组数据
                        if(!AppFate.$store.state.group.gotGroupData) {
                            if (data.group.length > 0) {
                                var resultData = GROUP_DATA_MANAGER.getGroupData(data.group);
                                AppFate.$store.state.group.gotGroupData = true;
                                AppFate.$store.state.group.groupData = resultData;
                            }
                        }
                        var groupData = AppFate.$store.state.group.groupData;
                        // 记录列表数据轮询拉取
                        if(data.info.length > 0){
                            var resultData = RECORD_DATA_MANAGER.getRecordListData(data.info, groupData);
                            state.recordFtime = resultData.biggest > 0 ? resultData.biggest : state.recordFtime;
                            state.recordOriginalData = RECORD_DATA_MANAGER.updateRecordOriginalData(state.recordOriginalData, resultData.original);
                            state.recordTotalData = RECORD_DATA_MANAGER.updateRecordListData(state.recordTotalData, resultData.result);
                            // 处理字母开头相关数据
                            AppFate.$store.dispatch('recordletter/updateRecordLetterListByList', resultData.letter);
                            resolve();
                        }else {
                            state.gotRecordData = true;
                            state.recordTotalData = RECORD_DATA_MANAGER.getResultListSort(state.recordTotalData);
                            state.noRecordData = state.recordTotalData.length > 0 ? false : true;
                            console.log("已经拉取完了", state.recordTotalData.length);
                            resolve();
                        }
                    });
                })
            }
            // 轮询
            function start() {
                async function timeFn () {
                    if(state.gotRecordData || tempArr.indexOf(state.recordFtime) != -1) {
                        return;
                    }
                    console.log('start------', state.recordFtime, tempArr)
                    tempArr.push(state.recordFtime);
                    await getData().then(function() {
                        setTimeout(timeFn, 20)
                    });
                }
                timeFn()
            }
            start()
        },
        [types.RECORD_INIT_RECENTLY_LIST](state) {
            API.getRecently({}, function(data){
                // 处理分组数据
                if(!AppFate.$store.state.group.gotGroupData) {
                    if (data.group.length > 0) {
                        var resultData = GROUP_DATA_MANAGER.getGroupData(data.group);
                        AppFate.$store.state.group.gotGroupData = true;
                        AppFate.$store.state.group.groupData = resultData;
                    }
                }
                
                // 处理列表数据
                if (data.info.length > 0) {
                    state.gotRecordRecentlyData = true;
                    var groupData = AppFate.$store.state.group.groupData;
                    var resultData = RECORD_DATA_MANAGER.getRecordRecentlyData(data.info, groupData);
                    state.largestGlanceTime = resultData.largest;
                    state.recordListData = resultData.list;
                    state.recordOriginalData = RECORD_DATA_MANAGER.updateRecordOriginalData(state.recordOriginalData, resultData.original);
                    state.noRecordData = false;
                }else{
                    state.noRecordData = true;
                }
                console.log('types.RECORD_INIT_RECENTLY_LIST', state.recordListData)
            });
        },
        [types.RECORD_DELETE_DATA](state, deleteId) {
            console.log("types.RECORD_DELETE_DATA", deleteId)
            API.deleteRecord({
                id: deleteId
            }, function (data) {
                if (data.ret) {
                    console.log("删除数据成功", deleteId);
                    window._czc.push(["_trackEvent", "八字模块", "八字", "删除八字"]);
                    
                    // 处理记录列表数据
                    AppFate.$store.dispatch('record/deleteRecordListData', [deleteId]);
                    // 处理搜索结果列表相关数据
                    AppFate.$store.dispatch('search/deleteSearchResultList', deleteId);
                    // 处理分组列表数据
                    var groupId = RECORD_DATA_MANAGER.getRecordGroupIdById(state.recordOriginalData, deleteId);
                    var groupData = AppFate.$store.state.group.groupData;
                    AppFate.$store.state.group.groupData = GROUP_DATA_MANAGER.deleteGroupListGroupData(groupData, [[deleteId, groupId]]);
                    // 处理过滤数据
                    setTimeout(() => {
                        AppFate.$store.dispatch('record/updateRecordFilterList');
                    }, 200);
                }
            });
        },
        [types.RECORD_DELETE_DATA_LIST_DATA](state, deleteArr) {
            var resultData = RECORD_DATA_MANAGER.deleteRecordListData(state.recordTotalData, deleteArr);
            state.recordTotalData = resultData.listData;
            setTimeout(() => {
                state.recordListData = [].concat(resultData.listData);
            }, 0);
            AppFate.$store.dispatch('recordletter/setRecordLetterList', resultData.letter);
        },
        [types.RECORD_OTHER_FILTER_DATA](state, filterData) {
            var totalData = AppFate.$store.state.allrecord.curFilterData.title == 'all' ? state.recordTotalData : state.recordListData;
            switch(filterData.type) {
                case 'createtime':
                    if(filterData.value == 0){
                        state.recordListData = totalData.sort((a, b) => {return a.createtime - b.createtime})
                    }else if(filterData.value == 1){
                        state.recordListData = totalData.sort((a, b) => {return b.createtime - a.createtime})
                    }
                    break;
                case 'recent':
                    // 最近浏览:只显示100条
                    state.recordListData = totalData.sort((a, b) => {return b.glance_time - a.glance_time}).slice(0, 100);
                    break;
                default:
                    break;
            }
            state.noRecordData = state.recordListData.length == 0 ? true : false;
        },
        [types.RECORD_UPDATE_FILTER_LIST_DATA](state) {
            console.log('types.RECORD_UPDATE_FILTER_LIST_DATA-------', state.recordCurOrderIndex);
            switch(state.recordCurOrderIndex) {
                case 1:
                    AppFate.$store.dispatch('allrecord/filterAllRecordList');
                case 2:
                    AppFate.$store.dispatch('record/filterOtherRecordList', {
                        type: 'createtime',
                        value: 1
                    });
                    break;
                case 3:
                    AppFate.$store.dispatch('record/filterOtherRecordList', {
                        type: 'recent',
                        value: 0
                    });
                    break;
            }
        },
        [types.RECORD_UPDATE_RECORD_LIST_DATA](state, data) {
            // 更新数据的查看时间
            state.largestGlanceTime++;
            data.glance_time = state.largestGlanceTime;

            var groupData = AppFate.$store.state.group.groupData;
            var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
            var recordOrigiData = {}; recordOrigiData[data.id] = data; 
            console.log('types.RECORD_UPDATE_RECORD_LIST_DATA', data, recordData, recordOrigiData)

            state.recordOriginalData = RECORD_DATA_MANAGER.updateRecordOriginalData(state.recordOriginalData, recordOrigiData);
            state.recordTotalData = RECORD_DATA_MANAGER.updateRecordListData(state.recordTotalData, [recordData]);
            state.recordListData = state.recordTotalData;
            // 处理字母开头相关数据
            AppFate.$store.dispatch('recordletter/updateRecordLetterListByList', [recordData.firstL]);
        },
        [types.RECORD_UPDATE_GROUP_NAME](state, data) {
            state.recordTotalData = RECORD_DATA_MANAGER.updateRecordListGroupName(state.recordTotalData, data.id, data.name);
            state.recordListData = state.recordTotalData;
        },
        [types.RECORD_UPDATE_GROUP_DATA](state, data) {
            var selectedList = data.selectedList, groupId = data.groupId, groupData = AppFate.$store.state.group.groupData;
            for(var arr of selectedList){
                state.recordOriginalData[arr[0]]['f_group'] = groupId;
                var index = UTILS.getIdIndexInObjectArray(state.recordTotalData, arr[0]);
                state.recordTotalData[index]['groupId'] = groupId;
                var groupIndex = UTILS.getIdIndexInObjectArray(groupData, groupId);
                state.recordTotalData[index]['group'] = groupData[groupIndex]['f_name'];
            }
        },
        [types.RECORD_UPDATE_DATA_PIPAN_STATUS](state, dataId) {
            // 嵌入式页面不更新列表数据
            var pathName = window.location.pathname;
            if(pathName.indexOf('embedded') != -1) {
                return;
            }
            var index = UTILS.getIdIndexInObjectArray(state.recordTotalData, dataId);
            if(state.recordOriginalData[dataId]) {
                state.recordOriginalData[dataId]['pipan'] = 1;
            }
            if(state.recordTotalData[index]) {
                state.recordTotalData[index]['pipan'] = 1;
            }
        },
        [types.RECORD_UPDATE_DATA_LUNPAN_STATUS](state, dataId) {
            console.log('types.RECORD_UPDATE_DATA_LUNPAN_STATUS----', dataId);
            // 嵌入式页面不更新列表数据
            var pathName = window.location.pathname;
            if(pathName.indexOf('embedded') != -1) {
                return;
            }
            var index = UTILS.getIdIndexInObjectArray(state.recordTotalData, dataId);
            if(state.recordOriginalData[dataId]) {
                state.recordOriginalData[dataId]['nunpan'] = 1;
            }
            if(state.recordTotalData[index]) {
                state.recordTotalData[index]['nunpan'] = 1;
            }
        },
        [types.RECORD_UPDATE_DATA_SITUATION](state, params) {
            // 嵌入式页面不更新列表数据
            var pathName = window.location.pathname;
            if(pathName.indexOf('embedded') != -1) {
                return;
            }
            var id = params.id, situation = params.situation,
                index = UTILS.getIdIndexInObjectArray(state.recordTotalData, id);
            console.log('situation------', state.recordOriginalData[id])
            state.recordOriginalData[id]['situation'] = situation;
            state.recordTotalData[index]['situation'] = situation;
        },
        [types.RECORD_UPDATE_DATA_STRONG](state, params) {
            // 嵌入式页面不更新列表数据
            var pathName = window.location.pathname;
            if(pathName.indexOf('embedded') != -1) {
                return;
            }
            var id = params.id, strong = params.strong,
                index = UTILS.getIdIndexInObjectArray(state.recordTotalData, id);
            console.log('strong------', state.recordOriginalData[id])
            state.recordOriginalData[id]['strong'] = strong;
            state.recordTotalData[index]['strong'] = strong;
        }
    },
    actions: {
        initRecordList({ commit }) {
            commit(types.RECORD_INIT_LIST);
        },
        initRecordRecentlyList({ commit }) {
            commit(types.RECORD_INIT_RECENTLY_LIST);
        },
        deleteRecordData({ commit }, dataArr) {
            commit(types.RECORD_DELETE_DATA, dataArr);
        },
        deleteRecordListData({ commit }, deleteArr) {
            commit(types.RECORD_DELETE_DATA_LIST_DATA, deleteArr)
        },
        filterOtherRecordList({ commit }, filterData) {
            commit(types.RECORD_OTHER_FILTER_DATA, filterData)
        },
        updateRecordFilterList({ commit }) {
            commit(types.RECORD_UPDATE_FILTER_LIST_DATA)
        },
        updateRecordListData({ commit }, data) {
            commit(types.RECORD_UPDATE_RECORD_LIST_DATA, data)
        },
        updateRecordListGroupName({ commit }, data) {
            commit(types.RECORD_UPDATE_GROUP_NAME, data)
        },
        updateRecordListGroupData({ commit }, data) {
            commit(types.RECORD_UPDATE_GROUP_DATA, data)
        },
        updateRecordListPipanStatus({ commit }, dataId) {
            commit(types.RECORD_UPDATE_DATA_PIPAN_STATUS, dataId)
        },
        updateRecordListLunpanStatus({ commit }, dataId) {
            commit(types.RECORD_UPDATE_DATA_LUNPAN_STATUS, dataId)
        },
        updateRecordListSituation({ commit }, params) {
            commit(types.RECORD_UPDATE_DATA_SITUATION, params)
        },
        updateRecordListStrong({ commit }, params) {
            commit(types.RECORD_UPDATE_DATA_STRONG, params)
        },
        updateRecordListAIStatus({ state }, params) {
            // 嵌入式页面不更新列表数据
            var pathName = window.location.pathname;
            if(pathName.indexOf('embedded') != -1) {
                return;
            }
            var id = params.id,
                index = UTILS.getIdIndexInObjectArray(state.recordTotalData, id);
            console.log('updateRecordListAIStatus------', state.recordOriginalData[id])
            state.recordOriginalData[id]['ai'] = 1;
            state.recordTotalData[index]['ai'] = 1;
        },
        checkRecordListSameSiZhu({state}, params) {
            state.recordSameEightWordList.splice(0);
            var resultList = RECORD_DATA_MANAGER.getRecordListSameSiZhuList(state.recordTotalData, params.formData);
            if(resultList.length > 0) {
                state.showSamePop = true;
                state.recordSameEightWordList = resultList;
            }else {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            }
        },
        setRecordList({state}, list) {
            state.noRecordData = list.length == 0 ? true : false;
            var newList = RECORD_DATA_MANAGER.getResultListSort(list);
            setTimeout(() => {
                state.recordListData = [].concat(newList);
            }, 0);
        },
        resetData({state}) {
            state.gotRecordData = false;
            state.gotRecordRecentlyData = false;
            state.recordFtime = 0;
            state.recordOriginalData = {};
            state.recordTotalData = [];
            state.largestGlanceTime = 0;
            state.recordListData = [];
            state.recordCurOrderIndex = 3;
            state.noRecordData = false;
            state.showSamePop = false;
            state.recordSameEightWordList = [];
        }
    }
}